<li [ngClass]="{ open: isOpenSection('shortcuts') }">
  <span class="notebook-sidebar-title" (click)="toggleSection('shortcuts')">
    <capra-icon icon="icon-chevron-right"></capra-icon> Keyboard Shortcuts
  </span>
  <div class="item-text">
    <h3>Command Mode (Esc to Enable)</h3>
    <div class="table">
      <div class="table-row clearfix">
        <div class="left-cell">Enter Edit Mode</div>
        <div class="right-cell">Return</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Run Cell</div>
        <div class="right-cell">&#8984;/Ctrl + Return</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Run Cell &amp; Advance</div>
        <div class="right-cell">Shift + Return</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Select Cell Above</div>
        <div class="right-cell">K or &uarr;</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Select Cell Below</div>
        <div class="right-cell">J or &darr;</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Insert Cell Above</div>
        <div class="right-cell">A</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Insert Cell Below</div>
        <div class="right-cell">B</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Move Cell Above</div>
        <div class="right-cell">Shift + Alt + &uarr;</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Move Cell Below</div>
        <div class="right-cell">Shift + Alt + &darr;</div>
      </div>
      <div class="table-row clearfix" *ngIf="!thoughtspotIntegrated">
        <div class="left-cell">Add Output to Report</div>
        <div class="right-cell">&#8984;/Ctrl + 1</div>
      </div>
      <div class="table-row clearfix" *ngIf="!thoughtspotIntegrated">
        <div class="left-cell">Remove from Report</div>
        <div class="right-cell">&#8984;/Ctrl + 2</div>
      </div>
    </div>
    <h3>Edit Mode (Enter to Enable)</h3>
    <div class="table">
      <div class="table-row clearfix">
        <div class="left-cell">Code Complete or Indent</div>
        <div class="right-cell">Tab</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Select All</div>
        <div class="right-cell">&#8984;/Ctrl + A</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Undo</div>
        <div class="right-cell">&#8984;/Ctrl + Z</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Run Cell</div>
        <div class="right-cell">&#8984;/Ctrl + Return</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Run Cell &amp; Advance</div>
        <div class="right-cell">Shift + Return</div>
      </div>
      <div class="table-row clearfix">
        <div class="left-cell">Insert Cell Below</div>
        <div class="right-cell">Opt/Alt + Return</div>
      </div>
      <div class="table-row clearfix" *ngIf="!thoughtspotIntegrated">
        <div class="left-cell">Add Output to Report</div>
        <div class="right-cell">&#8984;/Ctrl + 1</div>
      </div>
      <div class="table-row clearfix" *ngIf="!thoughtspotIntegrated">
        <div class="left-cell">Remove from Report</div>
        <div class="right-cell">&#8984;/Ctrl + 2</div>
      </div>
    </div>
  </div>
</li>
